export default {
   'features': '功能',
   'downloads': '下载',
   'roadmap': '路线图',
   'price': '价格',
   'donate': '捐赠',
   'feedback': '反馈',
   'panel': '控制面板',
};
